<template>
  <div class="last-powers">
      <div class="last-powers-input">
        <span class="trend-title" style="width:9rem">本月用量(国网电量)</span>
        <el-input type="number" placeholder="请输入" v-model="useData.monthUse">
          <template slot="suffix">KWH</template>
        </el-input>
        <span class="trend-title">昨日用量</span>
        <el-input type="number" placeholder="请输入" v-model="useData.yesUse">
          <template slot="suffix">KWH</template>
        </el-input>
        <span class="trend-title">较前日增长</span>
        <el-input type="number" placeholder="请输入" v-model="useData.yesAdd">
          <template slot="suffix">%</template>
        </el-input>
        <br>
        <br>
        <span class="trend-title">日均用量</span>
        <el-input type="number" placeholder="请输入" v-model="useData.dayUse">
          <template slot="suffix">KWH</template>
        </el-input>
        <span class="trend-title">较上月下降</span>
        <el-input type="number" placeholder="请输入" v-model="useData.monthDecline">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="last-save">
        <el-button :loading="lastPLoading" size="small" type="primary" @click="saveLastPower">保存</el-button>
      </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      lastPLoading:false,//加载状态
      //数据
      useData:{
        monthUse:'',//本月用量（国网电量）
        yesUse:'',//昨日用量
        yesAdd:'',//较前日
        dayUse:'',//日均用量
        monthDecline:'',//较上月
      },
    }
  },
  mounted(){
    this.getLastPowerList();//获取昨日用能信息
  },
  methods:{
    //保存昨日用能信息
    saveLastPower(){
      this.lastPLoading = true;
      apis.saveLastUse(this.useData).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.getLastPowerList();
          this.lastPLoading = false;
        }else{
          this.$message.error(res.message);
          this.lastPLoading = false;
          return;
        }
      })
    },
    //获取昨日用能信息
    getLastPowerList(){
      apis.getLastUse().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.useData = res.data
          }
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.last-powers{ padding-top: 10px;
  .last-powers-input{ margin-bottom: 15px;
    .trend-title{ width: 8.35rem;}
    .el-input,.el-select{ display: inline-block; width: 12rem;}
  }
}
</style>
